
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    Paper
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailConnectorModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";

export const EmailFromComponent: React.FC<{
  selectedEmailConnector: EmailConnectorModel | null,
  emailConnectors: EmailConnectorModel[],
  onChange: (event: any) => void
}> = ({
  selectedEmailConnector,
  emailConnectors,
  onChange
}) => {

  const styles = ContainerClasses();

  const error = () => {
    if(!selectedEmailConnector) return true;
    return false
  };

  return (
   <Box sx={{...styles.containerRowB,
             pt: '1rem',
             pl: '1rem',
             pr: '1rem',
             gap: '1rem'}}>

     <Typography
        variant="subtitle1"
      >
       From:
     </Typography>


    <FormControl
      fullWidth
      variant="filled"
    >
      <InputLabel
        required={true}
        error={error()}
      >
          From
      </InputLabel>

      <Select
        value={selectedEmailConnector?.Uuid_sys ?? ''}
        onChange={(event) => onChange(event)}
        size="small"
        disabled={false}
      >
        {emailConnectors.map((thisConnector) => {
           return (
             <MenuItem key={thisConnector.Uuid_sys} value={thisConnector.Uuid_sys}>{thisConnector.ReferencedUser_c.Email_c}</MenuItem>
           )
         })}
      </Select>
    </FormControl>
    </Box>
  )
};
